import * as React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { ToastContainer } from '@contrast-security-inc/design-system-alerts'

export function Bridge({ testId }) {
  return <ToastContainer testId={testId} />
}

export const reactToast = createNgReactBridgeDirective(
  'reactToast',
  [],
  Bridge,
  []
)
